// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	items: [],
	single: {},
};

function jobsReceived(state, payload) {
	if (payload.hasOwnProperty('items')) {
		return {...state, mainMenu: payload};
	}

	return state;
}

function allJobsReceived(state, payload) {
	return {...state, items: payload.jobs, meta: payload.meta};

	return state;
}

function jobReceived(state, payload) {
	return {...state, single: payload};

	return state;
}

function jobsRequested(state) {
	//We clear the data to always have it freshhh
	return {...state, items:[]};
}

function jobsRequestedSingle(state) {
	//We clear the data to always have it freshhh
	return {...state, single:{}};
}

export default function menuReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.JOBS_FETCH:
			return jobsReceived(state, action.payload);
		case actionTypes.JOBS_RECV_DATA:
			return allJobsReceived(state, action.payload);
		case actionTypes.JOBS_RECV_DATA_SINGLE:
			return jobReceived(state, action.payload);
		case actionTypes.JOBS_REQ_DATA:
			return jobsRequested(state);
		case actionTypes.JOBS_REQ_DATA_SINGLE:
			return jobsRequestedSingle(state);
			break;
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/jobs.js
 **/